import type { MatchedCompetitorProducts } from './MatchedSkinSeoulProduct';

export enum SkinSeoulProductType {
  Simple = 'Simple',
  Variable = 'Variable',
  Variation = 'Variation',
}

export enum PublicationStatus {
  PUBLISH = 'publish',
  DRAFT = 'draft',
  PENDING = 'pending',
  PRIVATE = 'private',
}

export enum StockStatus {
  IN_STOCK = 'instock',
  OUT_OF_STOCK = 'outofstock',
  ON_BACKORDER = 'onbackorder',
}

export enum CpProductStatus {
  IN_STOCK = 'instock',
  OUT_OF_STOCK = 'outofstock',
  OBSOLETE = 'obsolete',
  ERROR = 'error',
}

export enum Competitor {
  YesStyle = 'YesStyle',
  Stylevana = 'Stylevana',
  Amazon = 'Amazon',
  OliveYoung = 'OliveYoung',
  StyleKorean = 'StyleKorean',
}
export interface SkinSeoulProductIdentifier {
  sku: string;
  type: SkinSeoulProductType;
  variation?: SkinSeoulProductIdentifier[];
}

export interface MatchedSkinSeoulProduct {
  skinSeoulProduct: SkinSeoulProduct;
  machineMatchedProducts: MatchedCompetitorProducts[];
  humanMatchedProducts?: MatchedCompetitorProducts[];
}

export interface Price {
  currency: string;
  originalPrice?: number;
  salesPrice?: number;
}

export interface Product {
  sku: string;
  name: string;
  brand: string;
  productLink: string;
  productImageUrls?: string[];
  category: string[];
  size?: string;
  pack?: string;
  color?: string;
  originalPrice?: number;
  salePrice?: number;
  currency?: string;
  modifiedAt?: Date;
}

export interface SkinSeoulProduct extends Product {
  productId?: string;
  type?: SkinSeoulProductType;
  status?: StockStatus;
  description?: string;
  score?: number;
  variations?: SkinSeoulProduct[];
  parentProductId?: number;
  learnMoreUrl?: string[];
}

// color, size, pack are part of Product, and attribute_color, attribute_size, attribute_pack are part of ProductAttributes
export interface ProductAttributes {
  gp_product_id?: string;
  cp_parent_code?: string;
  cp_child_code?: string;
  cp_url?: string;
  wave?: string;
  source?: string;
  barcode?: string;

  // Product attributes
  attribute_size?: string;
  attribute_pack?: string;
  attribute_color?: string;

  // Names and descriptions
  cp_name_kr?: string;
  ss_name_only?: string;
  ss_name_kor?: string;
  title_with_brand?: string;
  highlight?: string;
  key_benefits?: string;
  key_ingredients?: string;

  // Coupang data
  cp_review_count?: string;
  cp_list_price?: string;
  cp_discount_price?: string;
  cp_shipping_date?: string;
  cp_product_status?: string;
  cp_last_scraped_at?: string;
  cp_last_error?: string;
  star?: string;

  // Tags
  efficacy_tags?: string;
  skin_concern_tags?: string;
  key_ingredient_tags?: string;
  skin_type_tags?: string;

  // WooCommerce/WordPress metadata
  logtivity_last_logged?: string;
  rank_math_internal_links_processed?: string;
  total_sales?: string;

  // Index signature for any additional attributes
  [key: string]: string | undefined;
}

export interface SkinSeoulAdminProduct extends SkinSeoulProduct {
  sourceLink?: string;
  nameKor?: string;
  postStatus?: PublicationStatus;
  attributes?: ProductAttributes;
  variations?: SkinSeoulAdminProduct[];
  additionalPrices: Price[];
}

/**
 * WooCommerce Order Status Enum
 */
export enum WooCommerceOrderStatus {
  PENDING = 'pending',
  PROCESSING = 'processing',
  ON_HOLD = 'on-hold',
  COMPLETED = 'completed',
  CANCELLED = 'cancelled',
  REFUNDED = 'refunded',
  FAILED = 'failed',
  SHIPPED = 'shipped',
  PREPARE_SHIPMENT = 'prepare-shipment',
}
